<template>
  <additional-features :additional-features-details="additionalFeaturesDetails"></additional-features>
</template>

<script>
// "Servizi" (Services), IBIPs-only field-catalog section (catalog: 11 Booleans,
// section_key == tab_key == "Services", DETAIL_PAGE_DESIGN.md). Uses
// components/ProductDetails/AdditionalFeatures.vue (prop-driven, no Vuex/parent coupling)
// instead of the generic FieldCatalogSection.vue — AdditionalFeatures.vue
// additionally shows a tooltip description per feature, which the generic label/value row has no slot
// for. Dispatched here via `fields`, not `payload` (same pattern as LiquiditySection.vue/
// CostsAtExpirationSection.vue — a typed section can be Fields-shaped when the backend itself treats
// the section as plain field-catalog). No DetailCard/section title here — there is exactly one
// section under this tab_key, so the tab header alone already provides that context.
//
// Labels/descriptions are NOT duplicated as new productDetails.fields.Services.* i18n keys: the
// backend's field keys (additionalOptions, mopFreeAllocation, ...) are the lowerFirst-cased
// AdditionalFeaturesTypes enum members, which already have an 'af'-prefixed pair of i18n entries
// (productDetails.additionalFeatures.af<Key>/additionalFeaturesDescriptions.af<Key>) used by
// AdditionalFeatures.vue — reused via the same "reuse via key transform"
// approach as UnderlyingsSection.vue for the UnderlyingAssetClass enum labels.
import AdditionalFeatures from '../../ProductDetails/AdditionalFeatures'

export default {
  name: 'services-section',
  components: {
    AdditionalFeatures,
  },
  props: {
    fields: { type: Array, required: true },
  },
  computed: {
    additionalFeaturesDetails() {
      return this.fields.map((field) => {
        const afKey = 'af' + field.key.charAt(0).toUpperCase() + field.key.slice(1)
        return {
          name: this.$t(`productDetails.additionalFeatures.${afKey}`),
          description: this.$t(`productDetails.additionalFeaturesDescriptions.${afKey}`),
          value: field.value,
        }
      })
    },
  },
}
</script>
